// Opens the invoice generated by the backend in a new tab AND saves a copy to disk.
//
// The backend returns two short-lived presigned S3 links for the same PDF:
//   invoiceUrl         - Content-Disposition: inline     (renders in a tab)
//   invoiceDownloadUrl - Content-Disposition: attachment (browser saves it)
// The attachment link is used for saving because <a download> is ignored for
// cross-origin URLs.
//
// Until S3 is configured the backend sends the PDF itself (invoicePdfBase64) instead,
// which is opened / saved from a local blob.

function clickLink(href, fileName) {
  const a = document.createElement('a');
  a.href = href;
  a.rel = 'noopener';
  if (fileName) a.download = fileName;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * @param {Object} data the submit response body
 * @param {Object} [opts] { open: boolean, save: boolean }
 * @returns {boolean} true when there was an invoice to show
 */
export function openAndSaveInvoice(data, opts = {}) {
  const { open = true, save = true } = opts;
  if (!data) return false;

  if (data.invoiceUrl) {
    if (open) window.open(data.invoiceUrl, '_blank');
    if (save) clickLink(data.invoiceDownloadUrl || data.invoiceUrl, data.invoiceFileName);
    return true;
  }

  if (data.invoicePdfBase64) {
    const bytes = Uint8Array.from(atob(data.invoicePdfBase64), (c) => c.charCodeAt(0));
    const blobUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
    if (open) window.open(blobUrl, '_blank');
    if (save) clickLink(blobUrl, data.invoiceFileName || 'invoice.pdf');
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60 * 1000);
    return true;
  }

  return false;
}

export default openAndSaveInvoice;
